import * as moment from 'moment';
var DateManipulator = /** @class */ (function () {
    function DateManipulator() {
    }
    DateManipulator.roundMomentTo15Min = function (time) {
        var remainder = 15 - (time.minute() % 15);
        return moment(time).add(remainder, 'minutes').set({ second: 0, millisecond: 0 });
    };
    DateManipulator.roundMinutesToInterval = function (time, interval) {
        var remainder = interval - (time.minute() % interval);
        var addedMinutes = moment(time).add(remainder, 'minutes');
        this.resetSeconds(addedMinutes);
        return addedMinutes;
    };
    DateManipulator.isTimeASAP = function (orderTime) {
        var currentTime = DateManipulator.roundMomentTo15Min(moment());
        var futureTime = moment(currentTime).add(5, 'minutes');
        return orderTime.isSameOrAfter(currentTime) && orderTime.isSameOrBefore(futureTime);
    };
    DateManipulator.isMomentToday = function (date) {
        var dateObj = moment(date);
        var today = moment();
        return dateObj.isSame(today, 'day');
    };
    DateManipulator.resetSeconds = function (dateObj) {
        dateObj.set({ seconds: 0, milliseconds: 0 });
    };
    return DateManipulator;
}());
export default DateManipulator;



//////////////////
// WEBPACK FOOTER
// ./src/utils/DateManipulator.ts
// module id = hFdg
// module chunks = 18